module.exports = __webpack_public_path__ + "static/media/whiteremindersbell.df510226.svg";